import clsx from 'clsx';

import styles from './KeyValueTable.module.scss';

type Props = {
  entries: [ string, string ][];
  keyLabel?: string;
  valueLabel?: string;
  'data-testid'?: string;
};

/**
 * White inner card listing key/value pairs (the Figma prompt-parameters and
 * API-headers tables). Column labels default to Key/Value.
 */
export function KeyValueTable( { entries, keyLabel = 'Key', valueLabel = 'Value', 'data-testid': dataTestId }: Props ) {
  return (
    <div className={ styles.table } data-testid={ dataTestId }>
      <div className={ clsx( styles.row, styles.headerRow ) }>
        <span className={ styles.headerCell }>{ keyLabel }</span>
        <span className={ styles.headerCell }>{ valueLabel }</span>
      </div>
      { entries.map( ( [ key, value ] ) => (
        <div className={ styles.row } key={ `kv-${ key }` }>
          <span className={ styles.cell }>{ key }</span>
          <span className={ styles.cell }>{ value }</span>
        </div>
      ) ) }
    </div>
  );
}
